import constate from 'constate'
import React, { useState } from 'react'

interface IAction {
  type: 'error' | 'success' | 'remove' | 'process'
  message: string
  icon?: string | null
  duration?: number
  priority?: number
}

export const useSnackbar = () => {
  const [open, setOpen] = useState(false)
  const [currentAction, setCurrentAction] = useState<IAction>({
    type: 'success',
    message: '',
    icon: '',
    duration: 6000,
    priority: 0,
  })
  const openSnackBar = (action: IAction) => {
    setCurrentAction((currentAction) => {
      if (currentAction.type === 'error' && currentAction.priority !== 0) {
        return currentAction
      }

      return action
    })
    setOpen(true)
  }

  const handleSnackBarClose = (event: React.SyntheticEvent | Event | null, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
    setCurrentAction({
      type: 'success',
      message: '',
      icon: '',
      duration: 6000,
    })
  }

  return { open, openSnackBar, action: currentAction, handleSnackBarClose }
}

const [SnackBarContainer, useSnackbarContext] = constate(useSnackbar)

export { SnackBarContainer, useSnackbarContext }
